/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { IconButton, Avatar } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

const DocumentSelectedBadge = () => {
    
    return (
        <Fragment>
            <div className='document-gallery-selected-badge-panel'>
                <Avatar
                    variant="circular"
                    className='document-gallery-selected-badge-avatar'
                >
                    <IconButton
                        className='document-gallery-selected-badge-icon'
                        aria-label='selected image'
                        component='span'
                    >
                        <CheckRoundedIcon />
                    </IconButton>
                </Avatar>
            </div>
        </Fragment>
    );
};

export { DocumentSelectedBadge };
